import React from "react";
import { FaCheck } from "react-icons/fa";
import "./SelectableOptionGrid.css";

const SelectableOptionGrid = ({ options = [], selectedValues = [], onToggle, disabled = false, className = "" }) => (
  <div className={`selectable-option-grid ${className}`}>
    {options.map((option) => {
      const selected = selectedValues.includes(option.value);
      return (
        <button
          type="button"
          key={option.value}
          className={`selectable-option ${selected ? "selected" : ""}`}
          aria-pressed={selected}
          disabled={disabled}
          onClick={() => onToggle(option.value)}
        >
          <span>{option.label}</span>
          {selected && <FaCheck aria-hidden="true" />}
        </button>
      );
    })}
  </div>
);

export default SelectableOptionGrid;
